
function deleteCookies() {
    const Cookies = document.cookie.split(";");
    for (let i = 0; i < Cookies.length; i++) {
        document.cookie = Cookies[i] + "=;expires=" + new Date(0).toUTCString();
    }
    return true;
}
export const removeCookiesThunkAction = () => async(dispatch) => {
    try {
        deleteCookies();
    } catch (e) {

    }
};
